// necessary for vs code autocompletion of json prisma types to work
// don't delete
import '@signupsoftware/server/prisma-types.js'
import { createRoot } from 'react-dom/client'

// import '@unimpaired/react/style.css' // This allows our style library to work
import './index.css' // This allows tailwind to work
import { App } from './App'

import * as Sentry from '@sentry/react'
import { SENTRY_CONFIG } from './config/sentry.config'
import { setupMaintenanceInterceptor } from './config/maintenance'

Sentry.init(SENTRY_CONFIG)

// Detect the deploy's 503 maintenance response and show the maintenance screen.
setupMaintenanceInterceptor()

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(<App />)
